import { Component } from '@angular/core';

@Component({
  selector: 'uni-card-description',
  templateUrl: './uni-card-description.component.html',
  styleUrls: ['./uni-card-description.component.scss'],
})
export class UniCardDescriptionComponent {
}
